import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MeasureUnitConfig } from '@cf-shared/measure-configs';

// The Input Measure test card's body on the Test UI Components page: cs-input-measure in every unit
// kind, chained with input-sequence, paired weight x reps, and custom serving units.
@Component({
  selector: 'cs-test-input-measure-card',
  host: { class: 'showcase-card-body' },
  templateUrl: 'cs-test-input-measure-card.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestInputMeasureCardComponent {
  bodyWeight = undefined;
  bodyWeightUnit = 'kg';
  skinfold = undefined;
  waist = undefined;
  waistUnit = 'cm';
  bodyHeight = undefined;
  bodyHeightUnit = 'cm';
  addedWeight = undefined;
  addedWeightUnit = 'kg';

  // Generate preselect values based on current unit
  get addedWeightPreselectValues(): number[] {
    if (this.addedWeightUnit === 'lb') {
      // For pounds, use 5 lb increments, but store as kg
      const lbValues = [];
      for (let lb = 10; lb <= 220; lb += 0.125) {
        lbValues.push(lb * 0.453592); // Convert lb to kg
      }
      return lbValues;
    } else {
      // For kg, use 5 kg increments
      const kgValues = [];
      for (let kg = 5; kg <= 100; kg += 0.25) {
        kgValues.push(kg);
      }
      return kgValues;
    }
  }

  reps = undefined;
  get repsPreselectValues(): number[] {
    const repValues = [];
    for (let r = 1; r <= 50; r++) {
      repValues.push(r);
    }
    return repValues;
  }

  // Egg measure test values for custom units
  showEggCustomUnit = false;
  eggWeight = 50; // Default to 50g (1 large egg)
  eggWeightUnit = 'g';
  eggCustomUnit = 'large';
  eggCustomUnitConfigs: MeasureUnitConfig[] = [
    { id: 'large', description: '1 large egg', unit1: 'large', value1: 50, fractionDenominatorMax: 8 },
    { id: 'extra_large', description: '1 extra large egg', unit1: 'extra large', value1: 56, fractionDenominatorMax: 8 },
    { id: 'jumbo', description: '1 jumbo egg', unit1: 'jumbo', value1: 63, fractionDenominatorMax: 8 },
    { id: 'cup', description: '1 cup (4.86 large eggs)', unit1: 'cup', value1: 243, fractionDenominatorMax: 8 },
    { id: 'medium', description: '1 medium egg', unit1: 'medium', value1: 44, fractionDenominatorMax: 8 },
    { id: 'small', description: '1 small egg', unit1: 'small', value1: 38, fractionDenominatorMax: 8 }
  ];

  onDoneClick() {
    // Placeholder for Done button click handler in test UI
    console.log('Done button clicked');
  }
}
